/**
 * 埋点上报
 *
 * - 运行期受 RuntimeConfig.trackEnabled 与 trackEndpoint 控制（见 build/env.js）。
 * - 关闭时所有 track 调用变 no-op，方便本地 / 测试环境零噪声。
 * - 若配置了 gaId，会在 setup 时注入一段极简 GA（gtag）启动脚本。
 *
 * 使用：
 *   track("promo_view", { page: "promo" })
 *   trackClick("promo_cta_main")   // 按钮点击快捷方式
 */

import { getRuntimeConfig } from "@/shared/config/env"

let ready = false

function injectGtag(gaId: string): void {
  if (typeof document === "undefined") return
  const script = document.createElement("script")
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`
  document.head.appendChild(script)

  const init = document.createElement("script")
  init.textContent = `window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}gtag('js',new Date());gtag('config','${gaId}');`
  document.head.appendChild(init)
}

export function setupTrack(runtime: RuntimeConfig = getRuntimeConfig()): void {
  if (ready) return
  ready = true

  if (runtime.trackEnabled && runtime.gaId) {
    injectGtag(runtime.gaId)
  }
}

export function isTrackEnabled(): boolean {
  const { trackEnabled, trackEndpoint } = getRuntimeConfig()
  return trackEnabled && Boolean(trackEndpoint)
}

export function track(
  event: string,
  payload: Record<string, unknown> = {},
): void {
  if (!isTrackEnabled()) return

  const { trackEndpoint } = getRuntimeConfig()
  const body = JSON.stringify({ event, ...payload, t: Date.now() })

  try {
    if (typeof navigator !== "undefined" && navigator.sendBeacon) {
      navigator.sendBeacon(trackEndpoint, body)
    } else {
      void fetch(trackEndpoint, { method: "POST", body, keepalive: true })
    }
  } catch {
    /* 上报失败不影响主流程 */
  }
}

/** 按钮点击埋点快捷方式 */
export function trackClick(trackId: string, payload: Record<string, unknown> = {}): void {
  track("click", { track_id: trackId, ...payload })
}
